const LABS_PREF = 'fslabs.labs'

const flagsWithPrefs = {
  NEW_EXPERIENCES: 'fslabs_discovery_new',
}

const flagsWithoutPrefs = {
  PROTOTYPES: 'discovery_prototypes',
  HERITAGE_PORTRAITS: 'discovery_heritage_portraits',
}

export const FLAGS = {
  ...flagsWithPrefs,
  ...flagsWithoutPrefs,
}

const flagsConfig = {
  labsPref: LABS_PREF,
  flagsWithPrefs: Object.values(flagsWithPrefs),
  flagsWithoutPrefs: Object.values(flagsWithoutPrefs),
}

export default flagsConfig
